import './Icon.css';

export type IconShape = { viewBox: string; elements: JSX.Element; fill?: string };
type IconProps = { shape: IconShape; size?: number; className?: string };
export function Icon({ shape, size = 20, className = '' }: IconProps): JSX.Element {
	return (
		<i className={className + ' icon'}>
			<svg
				fill={shape.fill || ''}
				version="1.2"
				baseProfile="tiny"
				xmlns="http://www.w3.org/2000/svg"
				viewBox={shape.viewBox}
				width={size}
				height={size}
			>
				{shape.elements}
			</svg>
		</i>
	);
}

export const empty = {
	viewBox: '0 0 1 1',
	elements: <></>,
};

export const broken_link = {
	viewBox: '0 0 60 60',
	elements: (
		<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.8032 10.4055V2.00781"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M41.1968 57.9924V49.5947"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.4055 18.8037H2.00781"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M57.9921 41.1973H49.5945"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.0558 30.1387L6.10188 34.0926C3.47565 36.7188 2.00024 40.2807 2.00024 43.9948C2.00024 45.8338 2.36247 47.6548 3.06623 49.3539C3.76999 51.0529 4.8015 52.5967 6.10188 53.897C7.40226 55.1974 8.94604 56.2289 10.6451 56.9327C12.3441 57.6365 14.1651 57.9987 16.0041 57.9987C19.7182 57.9987 23.2801 56.5233 25.9064 53.897L29.8602 49.9431"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M49.9446 29.861L53.8985 25.9071C56.5247 23.2808 58.0001 19.7189 58.0001 16.0048C58.0001 12.2908 56.5247 8.72885 53.8985 6.10262C51.2723 3.47638 47.7103 2.00098 43.9963 2.00098C40.2822 2.00098 36.7203 3.47638 34.094 6.10262L30.1401 10.0565"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
};

export const shopping_cart = {
	viewBox: '0 0 256 256',
	elements: (
		<>
			<rect width="256" height="256" fill="none"></rect>
			<path
				d="M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16"
				fill="none"
				stroke="#000000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			></path>
			<circle
				cx="80"
				cy="204"
				r="20"
				fill="none"
				stroke="#000000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			></circle>
			<circle
				cx="184"
				cy="204"
				r="20"
				fill="none"
				stroke="#000000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			></circle>
			<path
				d="M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48"
				fill="none"
				stroke="#000000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			></path>
		</>
	),
};

export const favorites_icon = {
	fill: 'none',
	viewBox: '0 0 20 20',
	elements: (
		<path
			d="M10.4447 16.5548L16.7728 10.2267C18.3275 8.66417 18.5541 6.10948 17.0853 4.47667C16.717 4.06519 16.2686 3.73314 15.7676 3.5008C15.2666 3.26846 14.7234 3.1407 14.1714 3.12535C13.6194 3.10999 13.07 3.20736 12.5568 3.41149C12.0437 3.61563 11.5775 3.92224 11.1869 4.31261L9.99938 5.50792L8.97594 4.47667C7.41344 2.92198 4.85875 2.69542 3.22594 4.16417C2.81446 4.53252 2.48241 4.98089 2.25007 5.4819C2.01772 5.98291 1.88997 6.52604 1.87462 7.07808C1.85926 7.63013 1.95663 8.17952 2.16076 8.69267C2.36489 9.20582 2.67151 9.67196 3.06188 10.0626L9.55406 16.5548C9.67256 16.6722 9.8326 16.738 9.99938 16.738C10.1662 16.738 10.3262 16.6722 10.4447 16.5548V16.5548Z"
			stroke="black"
			strokeWidth="1.7"
		/>
	),
};

export const heart = {
	viewBox: '0 0 20 20',
	elements: (
		<path
			d="M10.4447 16.5548L16.7728 10.2267C18.3275 8.66417 18.5541 6.10948 17.0853 4.47667C16.717 4.06519 16.2686 3.73314 15.7676 3.5008C15.2666 3.26846 14.7234 3.1407 14.1714 3.12535C13.6194 3.10999 13.07 3.20736 12.5568 3.41149C12.0437 3.61563 11.5775 3.92224 11.1869 4.31261L9.99938 5.50792L8.97594 4.47667C7.41344 2.92198 4.85875 2.69542 3.22594 4.16417C2.81446 4.53252 2.48241 4.98089 2.25007 5.4819C2.01772 5.98291 1.88997 6.52604 1.87462 7.07808C1.85926 7.63013 1.95663 8.17952 2.16076 8.69267C2.36489 9.20582 2.67151 9.67196 3.06188 10.0626L9.55406 16.5548C9.67256 16.6722 9.8326 16.738 9.99938 16.738C10.1662 16.738 10.3262 16.6722 10.4447 16.5548V16.5548Z"
			stroke="#787878"
			strokeWidth="1.25"
		/>
	),
};

export const heart_filled = {
	viewBox: '0 0 20 20',
	elements: (
		<path
			d="M10.4466 16.5548L16.7748 10.2267C18.3295 8.66417 18.556 6.10948 17.0873 4.47667C16.7189 4.06519 16.2705 3.73314 15.7695 3.5008C15.2685 3.26846 14.7254 3.1407 14.1734 3.12535C13.6213 3.10999 13.0719 3.20736 12.5588 3.41149C12.0456 3.61563 11.5795 3.92224 11.1888 4.31261L10.0013 5.50792L8.97789 4.47667C7.41539 2.92198 4.8607 2.69542 3.22789 4.16417C2.81641 4.53252 2.48436 4.9809 2.25202 5.4819C2.01968 5.98291 1.89193 6.52604 1.87657 7.07808C1.86122 7.63013 1.95858 8.17952 2.16271 8.69267C2.36685 9.20582 2.67346 9.67196 3.06383 10.0626L9.55602 16.5548C9.67451 16.6722 9.83455 16.738 10.0013 16.738C10.1681 16.738 10.3281 16.6722 10.4466 16.5548Z"
			fill="#78E989"
			stroke="#0C180B"
			strokeWidth="1.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
};

export const my_page = {
	fill: 'none',
	viewBox: '0 0 24 24',
	elements: (
		<>
			<path
				d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M2.90625 20.2485C3.82775 18.6521 5.15328 17.3264 6.74958 16.4046C8.34588 15.4829 10.1567 14.9977 12 14.9977C13.8433 14.9977 15.6541 15.4829 17.2504 16.4046C18.8467 17.3264 20.1722 18.6521 21.0938 20.2485"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const chevron_right = {
	viewBox: '0 0 24 24',
	elements: <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />,
};
export const chevron_left = {
	viewBox: '0 0 24 24',
	elements: <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />,
};

export const chevron_up = {
	viewBox: '0 0 24 24',
	elements: <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />,
};
export const chevron_down = {
	viewBox: '0 0 24 24',
	elements: <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />,
};

/** the design library's CaretRight, a 1.5px stroke in the text colour; rotate it for other directions */
export const caret_right = {
	viewBox: '0 0 16 16',
	fill: 'none',
	elements: (
		<path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	),
};

export const search = {
	viewBox: '0 0 256 256',
	elements: (
		<>
			<rect width="256" height="256" fill="none"></rect>
			<circle
				cx="116"
				cy="116"
				r="84"
				fill="none"
				stroke="#000000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			></circle>
			<line
				x1="175.4"
				y1="175.4"
				x2="224"
				y2="224"
				fill="none"
				stroke="#000000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			></line>
		</>
	),
};

export const thumbs_up = {
	viewBox: '0 0 100 100',
	elements: (
		<path d="M91.8 40H65.2C75.5 2 57.8 0 57.8 0c-7.2 0-5.7 5.8-6.2 6.8 0 18.8-19.8 33.3-19.8 33.3V93c0 5.2 7.3 7 10 7h40c3.7 0 6.7-9.8 6.7-9.8 10-33.7 10-43.8 10-43.8a6.3 6.3 0 0 0-6.8-6.3zm-71 0h-16a3.3 3.3 0 0 0-3.2 3.3l3.3 53.4a3.3 3.3 0 0 0 3.4 3.3H22c2.8 0 2.8-2.2 2.8-2.2V44a4 4 0 0 0-4-4z" />
	),
};

export const trash = {
	viewBox: '0 0 16 16',
	elements: (
		<>
			<path d="M13.5 3.5H2.5" stroke="#0C180B" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.5 6.5V10.5" stroke="#0C180B" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M9.5 6.5V10.5" stroke="#0C180B" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M12.5 3.5V13C12.5 13.1326 12.4473 13.2598 12.3536 13.3536C12.2598 13.4473 12.1326 13.5 12 13.5H4C3.86739 13.5 3.74021 13.4473 3.64645 13.3536C3.55268 13.2598 3.5 13.1326 3.5 13V3.5"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5 3.5V2.5C10.5 2.23478 10.3946 1.98043 10.2071 1.79289C10.0196 1.60536 9.76522 1.5 9.5 1.5H6.5C6.23478 1.5 5.98043 1.60536 5.79289 1.79289C5.60536 1.98043 5.5 2.23478 5.5 2.5V3.5"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const spinner = {
	viewBox: '0 0 24 24',
	elements: (
		<path d="m24 12-.33 2.8-.98 2.65-1.56 2.34-2.07 1.91-2.46 1.38-2.71.77-2.82.11-2.77-.54-2.56-1.18-2.22-1.74-1.74-2.22-1.19-2.56-.55-2.76.1-2.82.77-2.71 1.37-2.46 1.9-2.08 2.35-1.57L9.17.34l2.8-.34.02 6-1.4.17-1.33.49-1.17.79-.95 1.03-.69 1.23-.38 1.36-.05 1.41.28 1.38.59 1.28.87 1.1 1.11.88 1.28.59 1.38.27 1.41-.05 1.36-.39 1.23-.69 1.03-.95.79-1.18.48-1.32L18 12z">
			<animateTransform
				attributeName="transform"
				type="rotate"
				repeatCount="indefinite"
				dur="1.5s"
				values="0 12 12;360 12 12"
				keyTimes="0;1"
			/>
		</path>
	),
};

export const replacement_arrow = {
	viewBox: '0 0 512 512',
	elements: (
		<path d="m447.07 422.8-82.84 82.84c-4.24 4.24-9.79 6.36-15.34 6.36s-11.1-2.12-15.34-6.36a21.7 21.7 0 0 1 0-30.67l45.8-45.81h-245.5c-41.5 0-75.27-33.77-75.27-75.27V21.69a21.7 21.7 0 0 1 43.39 0v332.2a31.91 31.91 0 0 0 31.88 31.88h245.5l-45.8-45.8a21.7 21.7 0 0 1 30.68-30.69l82.84 82.84a21.69 21.69 0 0 1 0 30.68z" />
	),
};

export const exclamation_point = {
	viewBox: '0 0 24 24',
	elements: (
		<path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
	),
};

export const info = {
	viewBox: '0 0 24 24',
	elements: (
		<>
			<path
				d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
				fill="#78E989"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.25 11.25H12V16.5H12.75"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.8125 9C12.4338 9 12.9375 8.49632 12.9375 7.875C12.9375 7.25368 12.4338 6.75 11.8125 6.75C11.1912 6.75 10.6875 7.25368 10.6875 7.875C10.6875 8.49632 11.1912 9 11.8125 9Z"
				fill="black"
			/>
		</>
	),
};

export const info_outline = {
	viewBox: '0 0 24 24',
	fill: 'none',
	elements: (
		<>
			<circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
			<path d="M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			<path d="M12 11v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		</>
	),
};

export const store_front = {
	viewBox: '0 0 24 24',
	elements: (
		<path d="m21.9 8.89-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9 1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52 9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z" />
	),
};

export const company = {
	fill: 'none',
	viewBox: '0 0 20 21',
	elements: (
		<>
			<path
				d="M1.25 17.375H18.75"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.25 17.375V3.625C11.25 3.45924 11.1842 3.30027 11.0669 3.18306C10.9497 3.06585 10.7908 3 10.625 3H3.125C2.95924 3 2.80027 3.06585 2.68306 3.18306C2.56585 3.30027 2.5 3.45924 2.5 3.625V17.375"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5 17.375V8.625C17.5 8.45924 17.4342 8.30027 17.3169 8.18306C17.1997 8.06585 17.0408 8 16.875 8H11.25"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M5 6.125H7.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6.25 11.125H8.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5 14.25H7.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M13.75 14.25H15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M13.75 11.125H15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
};

export const door = {
	viewBox: '0 0 24 24',
	elements: (
		<>
			<path d="M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14z" />
			<path d="M9 11h2v2H9z" />
		</>
	),
};

export const home = {
	viewBox: '0 0 24 24',
	elements: <path d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z" />,
};

export const house = {
	fill: '#787878',
	viewBox: '0 0 14 15',
	elements: (
		<path d="M8.75244 13.5348V9.78378C8.75244 9.61797 8.68658 9.45896 8.56933 9.34171C8.45209 9.22447 8.29307 9.15861 8.12727 9.15861H5.62657C5.46076 9.15861 5.30175 9.22447 5.1845 9.34171C5.06726 9.45896 5.0014 9.61797 5.0014 9.78378V13.5348C5.0014 13.7006 4.93553 13.8596 4.81829 13.9769C4.70104 14.0941 4.54203 14.16 4.37622 14.16H0.625174C0.459368 14.16 0.300352 14.0941 0.183109 13.9769C0.0658665 13.8596 0 13.7006 0 13.5348V6.30625C0.00139979 6.21973 0.0200973 6.13436 0.0549917 6.05518C0.0898861 5.976 0.140272 5.90459 0.203182 5.84518L6.45493 0.16391C6.57017 0.0584736 6.72072 0 6.87692 0C7.03312 0 7.18366 0.0584736 7.29891 0.16391L13.5507 5.84518C13.6136 5.90459 13.6639 5.976 13.6988 6.05518C13.7337 6.13436 13.7524 6.21973 13.7538 6.30625V13.5348C13.7538 13.7006 13.688 13.8596 13.5707 13.9769C13.4535 14.0941 13.2945 14.16 13.1287 14.16H9.37762C9.21181 14.16 9.05279 14.0941 8.93555 13.9769C8.81831 13.8596 8.75244 13.7006 8.75244 13.5348Z" />
	),
};

export const person = {
	fill: 'none',
	viewBox: '0 0 20 21',
	elements: (
		<>
			<path
				d="M9.99219 6.125C11.2003 6.125 12.1797 5.14562 12.1797 3.9375C12.1797 2.72938 11.2003 1.75 9.99219 1.75C8.78406 1.75 7.80469 2.72938 7.80469 3.9375C7.80469 5.14562 8.78406 6.125 9.99219 6.125Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.0232 11.0234L14.7419 13.1328C14.9217 13.2824 15.1508 13.3595 15.3845 13.3488C15.6181 13.3381 15.8393 13.2405 16.0046 13.0752C16.17 12.9098 16.2676 12.6886 16.2782 12.455C16.2889 12.2214 16.2119 11.9922 16.0623 11.8125L12.9685 7.83594C12.8243 7.6903 12.6528 7.5746 12.4637 7.49549C12.2747 7.41639 12.0719 7.37544 11.8669 7.375H8.11695C7.70102 7.37723 7.30261 7.54276 7.00757 7.83594L3.91382 11.8125C3.75273 11.9913 3.66658 12.2252 3.67321 12.4658C3.67983 12.7064 3.77872 12.9352 3.9494 13.1049C4.12008 13.2745 4.34947 13.3721 4.59008 13.3773C4.83069 13.3825 5.06409 13.2949 5.24195 13.1328L7.9607 11.0234L5.78882 17.8672C5.7365 17.979 5.70671 18.1001 5.70117 18.2234C5.69562 18.3467 5.71442 18.47 5.7565 18.586C5.79858 18.7021 5.8631 18.8088 5.9464 18.8999C6.02969 18.991 6.13012 19.0649 6.24195 19.1172C6.35377 19.1695 6.47481 19.1993 6.59815 19.2048C6.72149 19.2104 6.84472 19.1916 6.96079 19.1495C7.07686 19.1074 7.18351 19.0429 7.27465 18.9596C7.36578 18.8763 7.43962 18.7759 7.49195 18.6641L9.99195 14.7266L12.4919 18.6641C12.5408 18.7808 12.6127 18.8864 12.7035 18.9746C12.7942 19.0627 12.9018 19.1316 13.0199 19.1771C13.138 19.2225 13.264 19.2436 13.3905 19.2391C13.5169 19.2345 13.6411 19.2045 13.7556 19.1506C13.8701 19.0968 13.9725 19.0204 14.0567 18.9259C14.1409 18.8315 14.205 18.721 14.2454 18.601C14.2857 18.4811 14.3014 18.3543 14.2914 18.2282C14.2814 18.1021 14.246 17.9793 14.1873 17.8672L12.0232 11.0234Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>{' '}
		</>
	),
};

export const pdf = {
	fill: 'none',
	viewBox: '0 0 20 21',
	elements: (
		<>
			<path
				d="M3.75 10.5V3.625C3.75 3.45924 3.81585 3.30027 3.93306 3.18306C4.05027 3.06585 4.20924 3 4.375 3H11.875L16.25 7.375V10.5"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.875 3V7.375H16.25"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.75 16.125H5C5.33152 16.125 5.64946 15.9933 5.88388 15.7589C6.1183 15.5245 6.25 15.2065 6.25 14.875C6.25 14.5435 6.1183 14.2255 5.88388 13.9911C5.64946 13.7567 5.33152 13.625 5 13.625H3.75V17.375"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.875 13.625H14.6875V17.375"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.5625 15.8125H14.6875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 17.375C10.4973 17.375 10.9742 17.1775 11.3258 16.8258C11.6775 16.4742 11.875 15.9973 11.875 15.5C11.875 15.0027 11.6775 14.5258 11.3258 14.1742C10.9742 13.8225 10.4973 13.625 10 13.625H8.90625V17.375H10Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const paypal = {
	fill: 'none',
	viewBox: '0 0 256 256',
	elements: (
		<>
			<path
				d="M144,128a48,48,0,0,0,46.56-36.36h0A48,48,0,0,0,144,32H84a8,8,0,0,0-7.76,6.06l-36,144A8,8,0,0,0,48,192H79.51a8,8,0,0,0,7.76-6.06l13-51.88A8,8,0,0,1,108,128Z"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			/>
			<path
				d="M87.27,185.94l-7,28.12A8,8,0,0,0,88,224h31.51a8,8,0,0,0,7.76-6.06l9-35.88A8,8,0,0,1,144,176h32a48,48,0,0,0,46.56-36.36h0A48,48,0,0,0,176,80H120a8,8,0,0,0-7.76,6.06l-12,48"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			/>
		</>
	),
};

export const mail = {
	fill: 'none',
	viewBox: '0 0 20 21',
	elements: (
		<>
			<path
				d="M17.5 4.875L10 11.75L2.5 4.875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 4.875H17.5V15.5C17.5 15.6658 17.4342 15.8247 17.3169 15.9419C17.1997 16.0592 17.0408 16.125 16.875 16.125H3.125C2.95924 16.125 2.80027 16.0592 2.68306 15.9419C2.56585 15.8247 2.5 15.6658 2.5 15.5V4.875Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.63281 10.5L2.69531 15.9453"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.3047 15.9453L11.3672 10.5"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const einvoice = {
	viewBox: '0 0 24 24',
	elements: (
		<path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" />
	),
};

export const prepaid = {
	viewBox: '0 0 24 24',
	elements: (
		<path d="M11 13V9c0-.55-.45-1-1-1H6V6h5V4H8.5V3h-2v1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4v2H4v2h2.5v1h2v-1H10c.55 0 1-.45 1-1zm8.59-.48-5.66 5.65-2.83-2.83-1.41 1.42L13.93 21 21 13.93z" />
	),
};

export const credit_card = {
	fill: 'none',
	viewBox: '0 0 20 21',
	elements: (
		<>
			<path
				d="M17.5 4.875H2.5C2.15482 4.875 1.875 5.15482 1.875 5.5V15.5C1.875 15.8452 2.15482 16.125 2.5 16.125H17.5C17.8452 16.125 18.125 15.8452 18.125 15.5V5.5C18.125 5.15482 17.8452 4.875 17.5 4.875Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.125 13.625H15.625"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.375 13.625H10.625"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.875 8.07031H18.125"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const plus_sign = {
	viewBox: '0 0 24 24',
	elements: <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />,
};

export const minus_sign = {
	viewBox: '0 0 24 24',
	elements: <path d="M19 13H5v-2h14v2z" />,
};

export const menu = {
	fill: '#0c180b',
	viewBox: '0 0 32 32',
	elements: (
		<>
			<path d="M5 16H27" stroke="#0C180B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5 8H27" stroke="#0C180B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5 24H27" stroke="#0C180B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
};

export const close = {
	fill: '#0c180b',
	viewBox: '0 0 24 24',
	elements: (
		<path d="M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
	),
};

export const filter_panel_close = {
	viewBox: '0 0 20 20',
	elements: (
		<>
			<path
				d="M15.625 4.375L4.375 15.625"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.625 15.625L4.375 4.375"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const filter_badge_close = {
	viewBox: '0 0 18 18',
	elements: (
		<>
			<mask id="mask0_4458_3176" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
				<rect width="24" height="24" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_4458_3176)">
				<path
					d="M9.0001 10.0501L5.3251 13.7251C5.1876 13.8626 5.0126 13.9313 4.8001 13.9313C4.5876 13.9313 4.4126 13.8626 4.2751 13.7251C4.1376 13.5876 4.06885 13.4126 4.06885 13.2001C4.06885 12.9876 4.1376 12.8126 4.2751 12.6751L7.9501 9.0001L4.2751 5.3251C4.1376 5.1876 4.06885 5.0126 4.06885 4.8001C4.06885 4.5876 4.1376 4.4126 4.2751 4.2751C4.4126 4.1376 4.5876 4.06885 4.8001 4.06885C5.0126 4.06885 5.1876 4.1376 5.3251 4.2751L9.0001 7.9501L12.6751 4.2751C12.8126 4.1376 12.9876 4.06885 13.2001 4.06885C13.4126 4.06885 13.5876 4.1376 13.7251 4.2751C13.8626 4.4126 13.9313 4.5876 13.9313 4.8001C13.9313 5.0126 13.8626 5.1876 13.7251 5.3251L10.0501 9.0001L13.7251 12.6751C13.8626 12.8126 13.9313 12.9876 13.9313 13.2001C13.9313 13.4126 13.8626 13.5876 13.7251 13.7251C13.5876 13.8626 13.4126 13.9313 13.2001 13.9313C12.9876 13.9313 12.8126 13.8626 12.6751 13.7251L9.0001 10.0501Z"
					fill="#1A1A1A"
				/>
			</g>
		</>
	),
};

export const filter_caret_down = {
	viewBox: '0 0 16 17',
	fill: 'none',
	elements: (
		<path
			d="M13 6.5L8 11.5L3 6.5"
			stroke="#0C180B"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
};

export const filter_caret_up = {
	viewBox: '0 0 16 17',
	fill: 'none',
	elements: (
		<path
			d="M3 10.5L8 5.5L13 10.5"
			stroke="#0C180B"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
};

export const sort_arrows = {
	viewBox: '0 0 21 20',
	fill: 'none',
	elements: (
		<>
			<path
				d="M9.25 13.75L6.75 16.25L4.25 13.75"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M6.75 3.75V16.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M11.75 6.25L14.25 3.75L16.75 6.25"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M14.25 16.25V3.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
};

export const filter_icon = {
	viewBox: '0 0 20 20',
	fill: 'none',
	elements: (
		<>
			<path
				d="M11.5625 13.4375H3.125"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.875 13.4375H14.6875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.125 15C13.9879 15 14.6875 14.3004 14.6875 13.4375C14.6875 12.5746 13.9879 11.875 13.125 11.875C12.2621 11.875 11.5625 12.5746 11.5625 13.4375C11.5625 14.3004 12.2621 15 13.125 15Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.5625 6.5625H3.125"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.875 6.5625H9.6875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.125 8.125C8.98794 8.125 9.6875 7.42544 9.6875 6.5625C9.6875 5.69956 8.98794 5 8.125 5C7.26206 5 6.5625 5.69956 6.5625 6.5625C6.5625 7.42544 7.26206 8.125 8.125 8.125Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const return_package = {
	viewBox: '0 0 24 24',
	elements: <path d="m6.83 11 1.59 1.59L7 14l-4-4 4-4 1.41 1.41L6.83 9H15c1.1 0 2 .9 2 2v9h-2v-9H6.83z" />,
};

export const checkmark = {
	viewBox: '0 0 24 24',
	elements: <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />,
};

export const checkmark_2 = {
	viewBox: '0 0 16 16',
	fill: 'none',
	elements: (
		<path
			d="M13.5 4.5L6.5 11.5L3 8"
			stroke="#0C180B"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
};

export const user_circle = {
	viewBox: '0 0 20 20',
	elements: (
		<>
			{' '}
			<path
				d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 12.5C11.7259 12.5 13.125 11.1009 13.125 9.375C13.125 7.64911 11.7259 6.25 10 6.25C8.27411 6.25 6.875 7.64911 6.875 9.375C6.875 11.1009 8.27411 12.5 10 12.5Z"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.98438 15.5781C5.45462 14.6519 6.17216 13.874 7.05745 13.3306C7.94275 12.7872 8.96123 12.4995 10 12.4995C11.0388 12.4995 12.0572 12.7872 12.9425 13.3306C13.8278 13.874 14.5454 14.6519 15.0156 15.5781"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const gift = {
	fill: 'none',
	viewBox: '0 0 120 120',
	elements: (
		<>
			<path
				d="M101.25 37.5H18.75C16.6789 37.5 15 39.1789 15 41.25V56.25C15 58.3211 16.6789 60 18.75 60H101.25C103.321 60 105 58.3211 105 56.25V41.25C105 39.1789 103.321 37.5 101.25 37.5Z"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M97.5 60V93.75C97.5 94.7446 97.1049 95.6984 96.4017 96.4017C95.6984 97.1049 94.7446 97.5 93.75 97.5H26.25C25.2554 97.5 24.3016 97.1049 23.5984 96.4017C22.8951 95.6984 22.5 94.7446 22.5 93.75V60"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M60 37.5V97.5" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M81.2344 32.2031C75.8906 37.5 60 37.5 60 37.5C60 37.5 60 21.6094 65.2969 16.2656C67.4103 14.1522 70.2768 12.9648 73.2656 12.9648C76.2545 12.9648 79.1209 14.1522 81.2344 16.2656C83.3478 18.3791 84.5352 21.2455 84.5352 24.2344C84.5352 27.2232 83.3478 30.0897 81.2344 32.2031V32.2031Z"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M38.7656 32.2031C44.1094 37.5 60 37.5 60 37.5C60 37.5 60 21.6094 54.7031 16.2656C52.5897 14.1522 49.7232 12.9648 46.7344 12.9648C43.7455 12.9648 40.8791 14.1522 38.7656 16.2656C36.6522 18.3791 35.4648 21.2455 35.4648 24.2344C35.4648 27.2232 36.6522 30.0897 38.7656 32.2031V32.2031Z"
				stroke="black"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const coins = {
	fill: '#000000',
	viewBox: '0 0 256 256',
	elements: (
		<>
			<rect width="256" height="256" fill="none" />
			<circle
				cx="204"
				cy="84"
				r="28"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<path
				d="M48,208H16a8,8,0,0,1-8-8V160a8,8,0,0,1,8-8H48"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<path
				d="M112,160h32l67-15.41a16.61,16.61,0,0,1,21,16h0a16.59,16.59,0,0,1-9.18,14.85L184,192l-64,16H48V152l25-25a24,24,0,0,1,17-7H140a20,20,0,0,1,20,20h0a20,20,0,0,1-20,20Z"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<path
				d="M176,85.29A28,28,0,1,1,192,58.71"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
		</>
	),
};

export const coins_two = {
	fill: '#000000',
	viewBox: '0 0 256 256',
	elements: (
		<>
			<ellipse
				cx="96"
				cy="84"
				rx="80"
				ry="36"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<path
				d="M16,84v40c0,19.88,35.82,36,80,36s80-16.12,80-36V84"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<line
				x1="64"
				y1="117"
				x2="64"
				y2="157"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<path
				d="M176,96.72c36.52,3.34,64,17.86,64,35.28,0,19.88-35.82,36-80,36-19.6,0-37.56-3.17-51.47-8.44"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<path
				d="M80,159.28V172c0,19.88,35.82,36,80,36s80-16.12,80-36V132"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<line
				x1="192"
				y1="165"
				x2="192"
				y2="205"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
			<line
				x1="128"
				y1="117"
				x2="128"
				y2="205"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="10"
			/>
		</>
	),
};

export const stock_package = {
	fill: 'none',
	viewBox: '0 0 20 20',
	elements: (
		<>
			<path
				d="M17.5 13.8492V6.14609C17.4994 6.03482 17.4695 5.92568 17.4132 5.82967C17.357 5.73365 17.2764 5.65417 17.1797 5.59922L10.3047 1.73203C10.2121 1.67855 10.107 1.65039 10 1.65039C9.89303 1.65039 9.78795 1.67855 9.69531 1.73203L2.82031 5.59922C2.72356 5.65417 2.643 5.73365 2.58676 5.82967C2.53052 5.92568 2.5006 6.03482 2.5 6.14609V13.8492C2.5006 13.9605 2.53052 14.0696 2.58676 14.1656C2.643 14.2617 2.72356 14.3411 2.82031 14.3961L9.69531 18.2633C9.78795 18.3168 9.89303 18.3449 10 18.3449C10.107 18.3449 10.2121 18.3168 10.3047 18.2633L17.1797 14.3961C17.2764 14.3411 17.357 14.2617 17.4132 14.1656C17.4695 14.0696 17.4994 13.9605 17.5 13.8492Z"
				fill="#78E989"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8281 11.9141V7.85156L6.25 3.67188"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.4141 5.82666L10.0703 9.99854L2.58594 5.82666"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.0703 10L10 18.3438"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const wallet = {
	viewBox: '0 0 256 256',
	elements: (
		<path d="M216,72H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24,24,0,0,0,32,64V192a24,24,0,0,0,24,24H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72Zm0,128H56a8,8,0,0,1-8-8V86.63A23.84,23.84,0,0,0,56,88H216Zm-48-60a12,12,0,1,1,12,12A12,12,0,0,1,168,140Z"></path>
	),
};

export const free_return_shipping = {
	viewBox: '0 0 256 256',
	elements: (
		<path d="M232,144a64.07,64.07,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H51.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,45.66L51.31,80H168A64.07,64.07,0,0,1,232,144Z"></path>
	),
};

export const play = {
	viewBox: '0 0 256 256',
	elements: (
		<path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm36.44-94.66-48-32A8,8,0,0,0,104,96v64a8,8,0,0,0,12.44,6.66l48-32a8,8,0,0,0,0-13.32ZM120,145.05V111l25.58,17Z"></path>
	),
};

export const pdf_file = {
	viewBox: '0 0 256 256',
	elements: (
		<path d="M224,152a8,8,0,0,1-8,8H192v16h16a8,8,0,0,1,0,16H192v16a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8h32A8,8,0,0,1,224,152ZM92,172a28,28,0,0,1-28,28H56v8a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8H64A28,28,0,0,1,92,172Zm-16,0a12,12,0,0,0-12-12H56v24h8A12,12,0,0,0,76,172Zm88,8a36,36,0,0,1-36,36H112a8,8,0,0,1-8-8V152a8,8,0,0,1,8-8h16A36,36,0,0,1,164,180Zm-16,0a20,20,0,0,0-20-20h-8v40h8A20,20,0,0,0,148,180ZM40,112V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0ZM160,80h28.69L160,51.31Z"></path>
	),
};

export const delivery = {
	fill: 'none',
	viewBox: '0 0 16 16',
	elements: (
		<>
			<path fillRule="evenodd" clipRule="evenodd" d="M1 4H11V5H14L15 7V12H11H1V4Z" fill="#78E989" />
			<path
				d="M2.75 12H1.5C1.36739 12 1.24021 11.9473 1.14645 11.8536C1.05268 11.7598 1 11.6326 1 11.5V4.5C1 4.36739 1.05268 4.24021 1.14645 4.14645C1.24021 4.05268 1.36739 4 1.5 4H11V10.7"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 7.5H15V11.5C15 11.6326 14.9473 11.7598 14.8536 11.8536C14.7598 11.9473 14.6326 12 14.5 12H13.25"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 5.00001H13.6625C13.7621 4.99936 13.8596 5.02886 13.9421 5.08463C14.0247 5.14041 14.0884 5.21984 14.125 5.31251L15 7.50001"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M1 9H11" stroke="#0C180B" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M10.25 12H5.75" stroke="#0C180B" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M11.75 13.5C12.5784 13.5 13.25 12.8284 13.25 12C13.25 11.1716 12.5784 10.5 11.75 10.5C10.9216 10.5 10.25 11.1716 10.25 12C10.25 12.8284 10.9216 13.5 11.75 13.5Z"
				fill="#78E989"
				stroke="#0C180B"
				strokeMiterlimit="10"
			/>
			<path
				d="M4.25 13.5C5.07843 13.5 5.75 12.8284 5.75 12C5.75 11.1716 5.07843 10.5 4.25 10.5C3.42157 10.5 2.75 11.1716 2.75 12C2.75 12.8284 3.42157 13.5 4.25 13.5Z"
				fill="#78E989"
				stroke="#0C180B"
				strokeMiterlimit="10"
			/>
		</>
	),
};

export const delivery_orange = {
	fill: 'none',
	viewBox: '0 0 16 16',
	elements: (
		<>
			<path fillRule="evenodd" clipRule="evenodd" d="M1 4H11V5H14L15 7V12H11H1V4Z" fill="#FFD363" />
			<path
				d="M2.75 12H1.5C1.36739 12 1.24021 11.9473 1.14645 11.8536C1.05268 11.7598 1 11.6326 1 11.5V4.5C1 4.36739 1.05268 4.24021 1.14645 4.14645C1.24021 4.05268 1.36739 4 1.5 4H11V10.7"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 7.5H15V11.5C15 11.6326 14.9473 11.7598 14.8536 11.8536C14.7598 11.9473 14.6326 12 14.5 12H13.25"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 5.00001H13.6625C13.7621 4.99936 13.8596 5.02886 13.9421 5.08463C14.0247 5.14041 14.0884 5.21984 14.125 5.31251L15 7.50001"
				stroke="#0C180B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M1 9H11" stroke="#0C180B" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M10.25 12H5.75" stroke="#0C180B" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M11.75 13.5C12.5784 13.5 13.25 12.8284 13.25 12C13.25 11.1716 12.5784 10.5 11.75 10.5C10.9216 10.5 10.25 11.1716 10.25 12C10.25 12.8284 10.9216 13.5 11.75 13.5Z"
				fill="#FFD363"
				stroke="#0C180B"
				strokeMiterlimit="10"
			/>
			<path
				d="M4.25 13.5C5.07843 13.5 5.75 12.8284 5.75 12C5.75 11.1716 5.07843 10.5 4.25 10.5C3.42157 10.5 2.75 11.1716 2.75 12C2.75 12.8284 3.42157 13.5 4.25 13.5Z"
				fill="#FFD363"
				stroke="#0C180B"
				strokeMiterlimit="10"
			/>
		</>
	),
};

export const not_in_stock = {
	fill: 'none',
	viewBox: '0 0 20 20',
	elements: (
		<>
			<path
				d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
				fill="#FFC499"
				stroke="black"
				strokeMiterlimit="10"
			/>
			<path d="M12.5 7.5L7.5 12.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12.5 12.5L7.5 7.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
};

export const caret_up = {
	fill: 'none',
	viewBox: '0 0 16 17',
	elements: (
		<path
			d="M3 10.5L8 5.5L13 10.5"
			stroke="#0C180B"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
};

export const caret_down = {
	fill: 'none',
	viewBox: '0 0 16 17',
	elements: (
		<path
			d="M13 6.5L8 11.5L3 6.5"
			stroke="#0C180B"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
};

export const caret_up_footer = {
	fill: 'none',
	viewBox: '0 0 24 24',
	elements: (
		<path
			d="M4.5 15L12 7.5L19.5 15"
			stroke="#0c180b"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	),
};

export const caret_down_footer = {
	fill: 'none',
	viewBox: '0 0 24 24',
	elements: (
		<path d="M19.5 9L12 16.5L4.5 9" stroke="#0c180b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	),
};

export const sliders = {
	fill: 'none',
	viewBox: '0 0 20 20',
	elements: (
		<>
			<path
				d="M11.5625 13.4375H3.125"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.875 13.4375H14.6875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.125 15C13.9879 15 14.6875 14.3004 14.6875 13.4375C14.6875 12.5746 13.9879 11.875 13.125 11.875C12.2621 11.875 11.5625 12.5746 11.5625 13.4375C11.5625 14.3004 12.2621 15 13.125 15Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.5625 6.5625H3.125"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.875 6.5625H9.6875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.125 8.125C8.98794 8.125 9.6875 7.42544 9.6875 6.5625C9.6875 5.69956 8.98794 5 8.125 5C7.26206 5 6.5625 5.69956 6.5625 6.5625C6.5625 7.42544 7.26206 8.125 8.125 8.125Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const filter_arrows = {
	fill: 'none',
	viewBox: '0 0 20 20',
	elements: (
		<>
			<path
				d="M8.75 13.75L6.25 16.25L3.75 13.75"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.25 3.75V16.25"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.25 6.25L13.75 3.75L16.25 6.25"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.75 16.25V3.75"
				stroke="#0C180B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const eco_tree = {
	fill: 'none',
	viewBox: '0 0 20 20',
	elements: (
		<>
			<g clipPath="url(#clip0_1030_95911)">
				<path
					d="M10.3518 14.156C10.9252 14.5465 11.5736 14.8135 12.2558 14.9398C12.938 15.0662 13.639 15.0492 14.3143 14.8899C14.9895 14.7307 15.6242 14.4326 16.1781 14.0147C16.7319 13.5968 17.1927 13.0683 17.5311 12.4626C17.8696 11.857 18.0783 11.1876 18.144 10.4969C18.2097 9.80624 18.1309 9.10945 17.9127 8.45087C17.6945 7.79229 17.3416 7.18634 16.8765 6.67153C16.4114 6.15673 15.8443 5.74436 15.2112 5.46064C15.0721 5.39075 14.9617 5.27478 14.8987 5.13252C14.4936 4.16765 13.8127 3.34388 12.9412 2.76457C12.0698 2.18526 11.0467 1.87622 10.0002 1.87622C8.95379 1.87622 7.93066 2.18526 7.05921 2.76457C6.18776 3.34388 5.50681 4.16765 5.10178 5.13252C5.03875 5.27478 4.9283 5.39075 4.78928 5.46064C4.15616 5.74436 3.58901 6.15673 3.12391 6.67153C2.65881 7.18634 2.30593 7.79229 2.08772 8.45087C1.86952 9.10945 1.79076 9.80624 1.85645 10.4969C1.92215 11.1876 2.13086 11.857 2.46932 12.4626C2.80777 13.0683 3.26856 13.5968 3.82238 14.0147C4.3762 14.4326 5.01092 14.7307 5.68618 14.8899C6.36144 15.0492 7.06246 15.0662 7.74464 14.9398C8.42682 14.8135 9.07524 14.5465 9.64866 14.156C9.75309 14.0874 9.87529 14.0509 10.0002 14.0509C10.1251 14.0509 10.2473 14.0874 10.3518 14.156Z"
					fill="#78E989"
					stroke="black"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 18.125V6.875"
					stroke="black"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 11.875L6.25 10"
					stroke="black"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 10L13.75 8.125"
					stroke="black"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1030_95911">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const eco_label_v3 = {
	fill: 'none',
	viewBox: '0 0 32 32',
	elements: (
		<>
			<path
				d="M16.5166 22.6803C17.3592 23.2745 18.3121 23.6806 19.3145 23.8728C20.3169 24.065 21.3471 24.0392 22.3393 23.7969C23.3316 23.5546 24.2643 23.1012 25.0781 22.4655C25.8919 21.8298 26.5691 21.0257 27.0664 20.1044C27.5638 19.1831 27.8704 18.1647 27.967 17.1141C28.0635 16.0634 27.9478 15.0034 27.6271 14.0016C27.3065 12.9997 26.788 12.0779 26.1045 11.2948C25.421 10.5117 24.5876 9.88434 23.6573 9.45274C23.453 9.34642 23.2907 9.17 23.1981 8.95359C22.6029 7.48579 21.6023 6.23265 20.3217 5.35139C19.0411 4.47012 17.5377 4 16 4C14.4623 4 12.9589 4.47012 11.6783 5.35139C10.3977 6.23265 9.39708 7.48579 8.80192 8.95359C8.7093 9.17 8.54699 9.34642 8.34271 9.45274C7.41236 9.88434 6.57895 10.5117 5.8955 11.2948C5.21205 12.0779 4.69351 12.9997 4.37286 14.0016C4.05221 15.0034 3.93648 16.0634 4.03301 17.1141C4.12955 18.1647 4.43625 19.1831 4.9336 20.1044C5.43095 21.0257 6.10806 21.8298 6.92188 22.4655C7.7357 23.1012 8.6684 23.5546 9.66067 23.7969C10.6529 24.0392 11.6831 24.065 12.6855 23.8728C13.6879 23.6806 14.6408 23.2745 15.4834 22.6803C15.6369 22.576 15.8164 22.5205 16 22.5205C16.1836 22.5205 16.3631 22.576 16.5166 22.6803Z"
				fill="#78E989"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M16 28V11" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M16 19L10 16" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M16 16L22 13" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
};

export const truck = {
	fill: 'none',
	viewBox: '0 0 20 21',
	elements: (
		<>
			<path
				d="M13.75 6.75001H17.0781C17.2026 6.7492 17.3245 6.78608 17.4277 6.85579C17.5309 6.92551 17.6105 7.02481 17.6562 7.14064L18.75 9.87501"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M1.25 11.75H13.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M14.6875 17.375C15.723 17.375 16.5625 16.5355 16.5625 15.5C16.5625 14.4645 15.723 13.625 14.6875 13.625C13.652 13.625 12.8125 14.4645 12.8125 15.5C12.8125 16.5355 13.652 17.375 14.6875 17.375Z"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M5.3125 17.375C6.34803 17.375 7.1875 16.5355 7.1875 15.5C7.1875 14.4645 6.34803 13.625 5.3125 13.625C4.27697 13.625 3.4375 14.4645 3.4375 15.5C3.4375 16.5355 4.27697 17.375 5.3125 17.375Z"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M12.8125 15.5H7.1875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.4375 15.5H1.875C1.70924 15.5 1.55027 15.4342 1.43306 15.3169C1.31585 15.1997 1.25 15.0408 1.25 14.875V6.125C1.25 5.95924 1.31585 5.80027 1.43306 5.68306C1.55027 5.56585 1.70924 5.5 1.875 5.5H13.75V13.875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.75 9.875H18.75V14.875C18.75 15.0408 18.6842 15.1997 18.5669 15.3169C18.4497 15.4342 18.2908 15.5 18.125 15.5H16.5625"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const house_2 = {
	fill: 'none',
	viewBox: '0 0 20 20',
	elements: (
		<>
			<path
				d="M16.875 16.875V9.02348C16.8736 8.93699 16.8549 8.85165 16.82 8.77249C16.7851 8.69332 16.7348 8.62194 16.6719 8.56255L10.4219 2.88286C10.3067 2.77745 10.1562 2.71899 10 2.71899C9.84384 2.71899 9.69334 2.77745 9.57812 2.88286L3.32812 8.56255C3.26523 8.62194 3.21486 8.69332 3.17998 8.77249C3.14509 8.85165 3.1264 8.93699 3.125 9.02348V16.875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.25 16.875H18.75"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.875 16.875V12.5C11.875 12.3342 11.8092 12.1753 11.6919 12.0581C11.5747 11.9408 11.4158 11.875 11.25 11.875H8.75C8.58424 11.875 8.42527 11.9408 8.30806 12.0581C8.19085 12.1753 8.125 12.3342 8.125 12.5V16.875"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const check_circle = {
	fill: 'none',
	viewBox: '0 0 16 16',
	elements: (
		<>
			<path
				d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
				fill="#78E989"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		</>
	),
};

export const hero_icon_pause = {
	fill: 'none',
	viewBox: '0 0 60 60',
	elements: (
		<>
			<g clipPath="url(#clip0_3525_65310)">
				<rect width="72" height="72" fill="#F5F5F5" />
				<path
					d="M37.4998 20.8333H33.7498C33.2896 20.8333 32.9165 21.2063 32.9165 21.6666V38.3333C32.9165 38.7935 33.2896 39.1666 33.7498 39.1666H37.4998C37.9601 39.1666 38.3332 38.7935 38.3332 38.3333V21.6666C38.3332 21.2063 37.9601 20.8333 37.4998 20.8333Z"
					fill="#F0F0F0"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M26.2498 20.8333H22.4998C22.0396 20.8333 21.6665 21.2063 21.6665 21.6666V38.3333C21.6665 38.7935 22.0396 39.1666 22.4998 39.1666H26.2498C26.7101 39.1666 27.0832 38.7935 27.0832 38.3333V21.6666C27.0832 21.2063 26.7101 20.8333 26.2498 20.8333Z"
					fill="#F0F0F0"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3525_65310">
					<rect width="60" height="60" rx="30" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const hero_icon_plus = {
	fill: 'none',
	viewBox: '0 0 60 60',
	elements: (
		<>
			<g clipPath="url(#clip0_3525_65319)">
				<rect width="72" height="72" fill="#F5F5F5" />
				<path
					d="M30 42.5C36.9036 42.5 42.5 36.9036 42.5 30C42.5 23.0964 36.9036 17.5 30 17.5C23.0964 17.5 17.5 23.0964 17.5 30C17.5 36.9036 23.0964 42.5 30 42.5Z"
					fill="#F0F0F0"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeMiterlimit="10"
				/>
				<path
					d="M24.792 30H35.2087"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M30 24.7917V35.2084"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3525_65319">
					<rect width="60" height="60" rx="30" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const hero_icon_wink = {
	fill: 'none',
	viewBox: '0 0 60 60',
	elements: (
		<>
			<g clipPath="url(#clip0_3525_65329)">
				<rect width="72" height="72" fill="#F5F5F5" />
				<path
					d="M30 40C35.5228 40 40 35.5228 40 30C40 24.4772 35.5228 20 30 20C24.4772 20 20 24.4772 20 30C20 35.5228 24.4772 40 30 40Z"
					fill="#F0F0F0"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27.4375 27.9165C27.4375 28.5723 26.9058 29.104 26.25 29.104C25.5942 29.104 25.0625 28.5723 25.0625 27.9165C25.0625 27.2607 25.5942 26.729 26.25 26.729C26.9058 26.729 27.4375 27.2607 27.4375 27.9165Z"
					fill="#1E3A22"
					stroke="#1E3A22"
					strokeWidth="0.125"
				/>
				<path
					d="M32.5 27.9165H35"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M34.3337 32.5C33.8931 33.259 33.261 33.8889 32.5005 34.3268C31.74 34.7647 30.8779 34.9952 30.0003 34.9952C29.1228 34.9952 28.2606 34.7647 27.5001 34.3268C26.7397 33.8889 26.1075 33.259 25.667 32.5"
					stroke="#1E3A22"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3525_65329">
					<rect width="60" height="60" rx="30" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const pencil_simple = {
	viewBox: '0 0 256 256',
	elements: (
		<path d="M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z"></path>
	),
};

export const pencil_simple_filled = {
	viewBox: '0 0 256 256',
	elements: (
		<path d="M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM192,108.68,147.31,64l24-24L216,84.68Z"></path>
	),
};

export const lock = {
	viewBox: '0 0 32 32',
	fill: 'none',
	elements: (
		<>
			<g clipPath="url(#clip0_4588_179582)">
				<path
					d="M26 11H6C5.44772 11 5 11.4477 5 12V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V12C27 11.4477 26.5523 11 26 11Z"
					stroke="#0C180B"
					strokeWidth="2.344"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16 20.5C16.8284 20.5 17.5 19.8284 17.5 19C17.5 18.1716 16.8284 17.5 16 17.5C15.1716 17.5 14.5 18.1716 14.5 19C14.5 19.8284 15.1716 20.5 16 20.5Z"
					fill="#0C180B"
				/>
				<path
					d="M11 11V7C11 5.67392 11.5268 4.40215 12.4645 3.46447C13.4021 2.52678 14.6739 2 16 2C17.3261 2 18.5979 2.52678 19.5355 3.46447C20.4732 4.40215 21 5.67392 21 7V11"
					stroke="#0C180B"
					strokeWidth="2.344"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4588_179582">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const bell = {
	viewBox: '0 0 32 32',
	fill: 'none',
	elements: (
		<>
			<g clipPath="url(#clip0_4588_179594)">
				<path
					d="M12 24C12 25.0609 12.4214 26.0783 13.1716 26.8284C13.9217 27.5786 14.9391 28 16 28C17.0609 28 18.0783 27.5786 18.8284 26.8284C19.5786 26.0783 20 25.0609 20 24"
					stroke="black"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.99984 13C6.99984 10.6131 7.94806 8.32387 9.63588 6.63604C11.3237 4.94821 13.6129 4 15.9998 4C18.3868 4 20.676 4.94821 22.3638 6.63604C24.0516 8.32387 24.9998 10.6131 24.9998 13C24.9998 17.4775 26.0373 21.075 26.8623 22.5C26.95 22.6518 26.9962 22.8239 26.9963 22.9991C26.9965 23.1744 26.9506 23.3466 26.8632 23.4985C26.7759 23.6504 26.6501 23.7767 26.4986 23.8647C26.3471 23.9527 26.1751 23.9994 25.9998 24H5.99984C5.82482 23.9989 5.65314 23.952 5.50195 23.8638C5.35077 23.7756 5.22539 23.6492 5.13833 23.4974C5.05127 23.3456 5.00559 23.1735 5.00586 22.9985C5.00613 22.8235 5.05233 22.6516 5.13984 22.5C5.96359 21.075 6.99984 17.4763 6.99984 13Z"
					stroke="black"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4588_179594">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const green_checkmark = {
	viewBox: '0 0 24 24',
	fill: 'none',
	elements: (
		<>
			<path
				d="M20.25 6.75L9.75 17.25L4.5 12"
				stroke="#78E989"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</>
	),
};

export const pencil_edit = {
	viewBox: '0 0 16 16',
	fill: 'none',
	elements: (
		<>
			<g clipPath="url(#clip0_4641_85761)">
				<path
					d="M5.79313 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3535C2.55268 13.2597 2.5 13.1326 2.5 13V10.2068C2.50006 10.0744 2.55266 9.9474 2.64625 9.85371L10.3538 2.14621C10.4475 2.05251 10.5746 1.99988 10.7072 1.99988C10.8397 1.99988 10.9669 2.05251 11.0606 2.14621L13.8538 4.93746C13.9474 5.03122 14.0001 5.15834 14.0001 5.2909C14.0001 5.42345 13.9474 5.55057 13.8538 5.64433L6.14625 13.3537C6.05255 13.4473 5.92556 13.4999 5.79313 13.5Z"
					fill="#78E989"
					stroke="#0C180B"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.5 4L12 7.5"
					stroke="#0C180B"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4641_85761">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const stats_chart = {
	viewBox: '0 0 89 88',
	fill: 'none',
	elements: (
		<>
			<g clipPath="url(#clip0_4807_183927)">
				<path
					d="M17 71.5V46.75H33.5"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M77.5 71.5H11.5"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M33.5 71.5V30.25H52.75"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M52.75 71.5V13.75H72V71.5"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4807_183927">
					<rect width="88" height="88" fill="white" transform="translate(0.5)" />
				</clipPath>
			</defs>
		</>
	),
};

export const arrows_clockwise = {
	viewBox: '0 0 88 88',
	fill: 'none',
	elements: (
		<>
			<g clipPath="url(#clip0_4807_183939)">
				<path
					d="M57.75 33H74.25V16.5"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M74.25 32.9999L64.5288 23.2787C58.8989 17.6491 51.2767 14.4659 43.3152 14.4196C35.3537 14.3732 27.695 17.4675 22 23.0312"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M30.25 55H13.75V71.5"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.75 55L23.4712 64.7212C29.1011 70.3509 36.7233 73.534 44.6848 73.5804C52.6463 73.6267 60.305 70.5325 66 64.9688"
					stroke="#0C180B"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4807_183939">
					<rect width="88" height="88" fill="white" />
				</clipPath>
			</defs>
		</>
	),
};

export const star = {
	viewBox: '0 0 256 256',
	fill: '#000000',
	elements: (
		<>
			<path d="M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.15a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86a16.46,16.46,0,0,0-9.37,28.86l45,38.83L53,211.75a16.38,16.38,0,0,0,24.5,17.82L128,198.49l50.53,31.08A16.4,16.4,0,0,0,203,211.75l-13.76-58.07,45-38.83A16.43,16.43,0,0,0,239.18,97.26Zm-15.34,5.47-48.7,42a8,8,0,0,0-2.56,7.91l14.88,62.8a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-54.72-33.65a8,8,0,0,0-8.38,0L69.09,215.94c-.15.09-.19.12-.38,0a.37.37,0,0,1-.17-.48l14.88-62.8a8,8,0,0,0-2.56-7.91l-48.7-42c-.12-.1-.23-.19-.13-.5s.18-.27.33-.29l63.92-5.16A8,8,0,0,0,103,91.86l24.62-59.61c.08-.17.11-.25.35-.25s.27.08.35.25L153,91.86a8,8,0,0,0,6.75,4.92l63.92,5.16c.15,0,.24,0,.33.29S224,102.63,223.84,102.73Z"></path>
		</>
	),
};

export const download = {
	viewBox: '0 0 32 32',
	fill: 'none',
	elements: (
		<>
			<g clipPath="url(#clip0_4860_210465)">
				<path d="M16 18V4" stroke="#0C180B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M27 18V26H5V18"
					stroke="#0C180B"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M21 13L16 18L11 13"
					stroke="#0C180B"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</>
	),
};
